Ext.define('SA.view.ImportStatusWindow', {
    alias: 'widget.import-status-window',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-import-status-window',
    includeCloseBtn: false,
    includeFooter: false,
    title: 'Importing Data',

    getBodyItems() {
        return {
            xtype: 'component',
            itemId: 'body',

            tpl: [
                '<tpl if="uploadProgress < 100">',
                    '<table>',
                        '<tr><td>Uploading:</td><td>{uploadProgress}% done.</td></tr>',
                    '</table>',
                '<tpl else>',
                    '<table>',
                        '<tr><td>Uploading:</td><td>Done.</td></tr>',
                        '<tr><td>Processing:</td><td>{indicator}</td></tr>',
                    '</table>',
                '</tpl>'
            ]
        };
    },

    initComponent() {
        this.callParent();

        this.indicator = new SA.view.ImportProcessingIndicator({maxDotCount: 20});
        this.indicatorIntervalDuration = 300;

        this.body = this.down('#body');

        this.setUploadProgress(0);
    },

    beforeDestroy() {
        this.callParent();

        this.indicator = null;
        this.clearIndicatorRefreshInterval();
    },

    clearIndicatorRefreshInterval() {
        clearInterval(this.indicatorInterval);
    },

    setProcessing() {
        var getTplData = () => ({uploadProgress: 100, indicator: this.indicator.getNext()}),
            refresh = () => this.body.update(getTplData());

        refresh();

        this.indicatorInterval = setInterval(refresh, this.indicatorIntervalDuration);
    },

    setUploadProgress(uploadProgress) {
        this.body.update({uploadProgress});
    }
});